import { combineReducers } from 'redux'
import {
  createReducer,
  createRequestReducer
} from 'pobble-components/dist/redux-helpers'

const ConflictsReducer = combineReducers({
  fetchConflictsRequest: createRequestReducer('CONFLICTS_STORE:FETCHING'),
  refetchConflictsRequest: createRequestReducer('CONFLICTS_STORE:REFETCHING'),
  retireStudentRequest: createRequestReducer('CONFLICTS_STORE:RETIRE'),
  resolveConflictRequest: createRequestReducer('CONFLICTS_STORE:RESOLVE'),
  conflicts: createReducer(null, {
    'CONFLICTS_STORE:FETCHING_REQUEST_SUCCESS': (state, { response }) =>
      response.data.data,
    'CONFLICTS_STORE:REFETCHING_REQUEST_SUCCESS': (state, { response }) =>
      response.data.data
  }),
  step: createReducer(1, {
    'CONFLICTS_STORE:SET_STEP_SUCCESS': (state, { step }) => step
  })
})

export default ConflictsReducer
